export const listAllPages = async (fetchPage) => {
  const all = [];
  let page = 1;
  for (;;) {
    const response = await fetchPage(page);
    all.push(...(response.results || []));
    if (all.length >= response.count || !response.results?.length) break;
    page += 1;
  }
  return all;
};

export const sdkDatesToStrings = (obj, { dates = [], datetimes = [] }) => {
  if (!obj) return obj;
  const out = { ...obj };
  for (const f of dates) if (out[f] instanceof Date) out[f] = out[f].toISOString().slice(0, 10);
  for (const f of datetimes) if (out[f] instanceof Date) out[f] = out[f].toISOString();
  return out;
};

export const sdkStringsToDates = (obj, fields, { omitEmpty = false } = {}) => {
  const out = { ...obj };
  for (const f of fields) {
    if (!(f in out)) continue;
    const value = out[f];
    if (value) {
      out[f] = value instanceof Date ? value : new Date(value);
    } else if (omitEmpty) {
      delete out[f];
    } else {
      out[f] = null;
    }
  }
  return out;
};
